<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.edit') }} {{ $tc('message.specialties', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form @reset="onReset" v-if="show">
                    <b-container>
                        <b-row>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="profession-group"
                                        :label="$tc('message.professions', 1)"
                                        label-for="profession">
                                    <b-form-select
                                            id="profession"
                                            v-model="$v.form.profession_id.$model"
                                            :state="$v.form.profession_id.$dirty ? !(errorshasField('profession_id') || $v.form.profession_id.$error) : null"
                                            :options="mProfessions"
                                            required
                                            @focus="clearErrorField('profession_id')"
                                    ></b-form-select>

                                    <b-form-invalid-feedback v-if="!$v.form.profession_id.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('profession_id')">
                                        {{ getErrorsField('profession_id') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="nom-group"
                                        :label="$t('message.name')"
                                        label-for="nom"
                                        description=""
                                >
                                    <b-form-input
                                            id="nom"
                                            v-model="$v.form.name.$model"
                                            :state="$v.form.name.$dirty ? !(errorshasField('name') || $v.form.name.$error) : null"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('name')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.name.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.form.name.minLength">
                                        {{ $t('message.minCharacters', { n: 3 }) }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-else-if="errorshasField('name')">
                                        {{ getErrorsField('name') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="justify-content-sm-center" v-if="can">
                            <b-button @click="onSubmit"  variant="primary">
                                {{ $t('message.edit') }}
                            </b-button>

                        </b-row>
                    </b-container>


                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required,minLength } from 'vuelidate/lib/validators';
    import _ from 'lodash';

    export default {
        name: "EditSpecialty",

        computed: {
            ...mapGetters(["specialty", "professions", "errors",'hasAdminRole',
                'hasGestionnaireRole']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole;
            },

            form: function() {
                return this.specialty;
            },

            mProfessions: function() {
                let pArray = [];

                _.forOwn(this.professions, function(value, key) {
                    pArray.push({ text: value.name, value: value.id });
                });

                return pArray;
            }
        },

        data() {
            return {
                specialty_id: this.$route.params.specialty,
                show: true
            }
        },

        methods: {
            getSpecialty: function() {
                let args = {
                    specialty: this.specialty_id
                };
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getSpecialty', { args, errorMessages });
            },

            getProfessions: function() {
                let args = {};
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getProfessions', { args, errorMessages });
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        specialty: this.specialty_id,
                        name: this.form.name,
                        profession_id: this.form.profession_id
                    };

                    let successMessage = this.$i18n.t('message.specialtyUpdated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('updateSpecialty', { args, errorMessages, successMessage })
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                        });
                }
            },

            onReset: function(evt) {
                /*evt.preventDefault();

                // Reset our form values
                this.form.nom = '';
                this.form.profession_id = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });*/
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                name: {
                    required,
                    minLength: minLength(3)

                },
                profession_id: {
                    required
                }
            }
        },

        mounted() {
            // Retrieve the specialty
            this.getSpecialty();

            // Retrieve list of professions
            this.getProfessions();
        }
    }
</script>

<style scoped>

</style>
